import { render, staticRenderFns } from "./NewMrrReport.vue?vue&type=template&id=82916bd0&scoped=true&"
import script from "./NewMrrReport.vue?vue&type=script&lang=js&"
export * from "./NewMrrReport.vue?vue&type=script&lang=js&"
import style0 from "./NewMrrReport.vue?vue&type=style&index=0&id=82916bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82916bd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
